// @flow

const EXPANSION_VARIANTS = {
  collapsed: {
    opacity: 0,
    height: 0,
    y: -200,
  },
  expanded: {
    opacity: 1,
    height: 'auto',
    y: 0,
  },
};

const SPLIT_NAV_EXPANSION_VARIANTS = {
  collapsed: {
    opacity: 0,
    height: 0,
    y: -10,
  },
  expanded: {
    opacity: 1,
    height: 'auto',
    y: 0,
  },
};

export const getExpansionVariants = (type?: string) =>
  type === 'split' ? SPLIT_NAV_EXPANSION_VARIANTS : EXPANSION_VARIANTS;
